import { render } from "./faturas.vue?vue&type=template&id=a44b1678&scoped=true"
import script from "./faturas.vue?vue&type=script&lang=js"
export * from "./faturas.vue?vue&type=script&lang=js"

import "./faturas.vue?vue&type=style&index=0&id=a44b1678&scoped=true&lang=scss"

import exportComponent from "/var/www/amee/iptu-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a44b1678"]])

export default __exports__